<template>
  <NuxtLink :to="localePath('/our-portfolio')" class="circle-dazzling">
    <div class="circle-dazzling__text heading">SEE OUR DAZZLING</div>
    <div class="circle-dazzling__text heading-hightlight">PROJECTS!</div>
    <div class="circle-dazzling__icon">
      <i class="icon-arrow-button"></i>
    </div>
  </NuxtLink>
</template>

<script setup>
  const localePath = useLocalePath();
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .circle-dazzling {
      .circle-dazzling__text {
        @include font-size("display-5", $lang);

        &.heading {
          @include font-weight("bold", $lang);
        }
      }
    }
  }
}

.circle-dazzling {
  text-align: center;
  width: 364px;
  height: 364px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $white;
  color:$black;
  border-radius: 50%;
  margin: 2rem auto 0 auto;
  padding-top: 4rem;

  .circle-dazzling__icon {
    margin-top: 1.25rem;

    i {
      font-size: px-to-rem(26);
    }
  }

  -webkit-animation-duration: 3s;
  animation-duration: 3s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;

  @include hover {
    cursor: pointer;
    animation-name: bounce;
    -moz-animation-name: bounce;
  }
}

@keyframes bounce {
  80% {
    -webkit-transform: translateY(15px);
    -ms-transform: translateY(15px);
    transform: translateY(15px);
  }

  40% {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  60% {
    -webkit-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    transform: translateY(-15px);
  }

  80% {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }
}
</style>